<template>
  <div class="input-tags">
    <span class="badge tag" v-for="(tag, index) in tags" :key="tag">
      <span class="">
        {{ tag }}
      </span>
      <img
        class="remove"
        src="/static/icons/close-thin.svg"
        alt="remove"
        @click="removeTag(index)"
      />
    </span>
    <input
      type="text"
      class="add-tag"
      name=""
      id=""
      @keyup.enter="setTag"
      @keyup.space="setTag"
      v-model="newTag"
      placeholder="เพิ่ม Tag ที่นี่..."
    />
  </div>
</template>

<script>
export default {
  props: ["tags"],
  data() {
    return {
      newTag: ""
    };
  },
  methods: {
    setTag() {
      const dup = this.checkDupicate(this.newTag);
      if (!dup && this.newTag) {
        this.tags.push(this.newTag);
        this.newTag = "";
        this.updateTag();
      }
    },
    removeTag(index) {
      this.tags.splice(index, 1);
    },
    checkDupicate(input) {
      for (let i = 0; i < this.tags.length; i += 1) {
        if (input === this.tags[i]) {
          return true;
        }
      }
      return false;
    },
    updateTag() {
      this.$emit("updateTag", this.tags);
    }
  }
};
</script>

<style scoped>
.tag {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;
  background-color: #fff;
  padding: 3px 10px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  margin: 0 5px 5px 0;
}
.add-tag {
  font-size: 18px;
  font-weight: 500;
  color: #000;
  width: 120px;
  border: none;
}
.media-body {
  width: auto;
}
.remove {
  opacity: 0.6;
  height: 20px;
  margin-bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/helper/InputTag.vue